export default __webpack_public_path__ + "static/media/leftimg.3ae4cc68.png";